import { Component, OnInit, Input } from '@angular/core';
import { MainPageService } from '../../../main-page.service';
import { CrossSectionModel } from '../../../../models/parts/cross-section.model';
import { CrossSectionManagmentComponent } from '../cross-sections-managment/cross-sections-managment.component';
import { SystemModel } from '../../../../models/dictionaries/system.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';

declare var $: any;


@Component({
  selector: 'app-cross-section-grid',
  template: `<!-- <div [hidden]="isConnectorHidden">
    <hc-data-grid id="mainGrid" (onAddClick)="addConnector()" [data]="myArray" [select]="false" [headers]="headers" [subheader]="true" [displayedColumns]="displayedColumns" (onEditClick)="onConnectorClick($event)">
    </hc-data-grid>
</div> -->

<!-- Edit Modal -->
<div class="modal" id="addCrossSectionModal">
    <div class="modal-dialog">
        <div class="form">
            <form class="form-group" [formGroup]="formGroup">
                <div class="modal-content">

                    <!-- Modal Header -->
                    <div class="modal-header">
                            <span><i class="fa fa-plus-circle"></i></span>
                            <span class="modal-header1">create: </span>
                            <span class="modal-header2">new product</span>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body display-flex">
                        <div class="w100">
                            <div>
                                <div class="display-flex modalInputBorder">
                                    <span class="modal-label">Name:</span>
                                    <input type="text" [(ngModel)]="templateCrossSection.name" formControlName="name">
                                </div>
                                <div class="modalInputBorder">
                                    <span class="modal-label">Description:</span>
                                    <textarea [(ngModel)]="templateCrossSection.description" formControlName="description">>
                                    </textarea>
                                </div>
                                <div class="display-flex modalInputBorder">
                                    <span class="modal-label">System:</span>
                                    <select name="systemSelect" class="selectHeight w-select-calc" [(ngModel)]="templateCrossSection.system" formControlName="system">
                                        <option *ngFor="let system of systemsArray | sortByName" [ngValue]="system.name">{{system.name}}</option>
                                    </select>
                                </div>
                                <div class="display-flex modalInputBorder">
                                    <span class="modal-label w-121">DUENQ Name:</span>
                                    <input type="text" [(ngModel)]="templateCrossSection.duenqName" formControlName="duenqName" maxlength="50">
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <button type="button" class="btn cancel-button" data-dismiss="modal">Cancel</button>
                        <button type="submit" class="btn red-button" data-dismiss="modal" [disabled]="formGroup.invalid" (click)="saveNewCrossSection()">Create</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<div class="input-effect">
    <input class="effect1" type="text" placeholder="">
    <label>Search</label>
    <span class="focus-border"></span>
</div>
<button class="red-button" type="button" data-toggle="modal" data-target="#addCrossSectionModal" (click)="prepareCreate()">Create</button>

<table>
    <tr>
        <th *ngFor="let header of headers">{{header}}</th>
    </tr>
    <tr *ngFor="let crossSection of crossSectionGridData, let row_no = index" (click)="onRowClick(row_no, crossSection._id)"
        style="cursor:pointer" [class.highlighted]="crossSection._id === selectedRowId">
        <td class="column-width">{{crossSection.name}}</td>
        <td class="column-width">{{crossSection.description}}</td>
    </tr>
</table>`,
  styles: [`table{font-family:arial,sans-serif;border-collapse:collapse;width:100%}td,th{border:1px solid #ddd;text-align:left;padding:8px}tr:nth-child(even){background-color:#ddd}.display-flex{display:flex;align-items:center;margin-bottom:10px}.search-input{border:none;border-bottom:1px solid gray;outline:0;margin-right:10px}.highlighted{background-color:#534f53!important;color:#fff}#addCrossSectionModal input,select{border:none;outline:0;font-size:14px}.modal-label{font-size:14px;color:#969696;font-weight:400;width:auto}.modalInputBorder{border-bottom:1px solid #969696;width:100%;padding-bottom:5px}.w100{width:100%}#addCrossSectionModal input{margin-left:8px;width:100%}.w-121{width:121px}.w-select-calc{width:calc(100% - 50px)}.selectHeight{height:21px}.modalInputBorder:not(:last-child){margin-bottom:26px}#addCrossSectionModal textarea{border:none;resize:none;display:block;width:100%;outline:0;font-size:14px}.modal-content{border-radius:0}.modal-header{background-color:#f5f5f5;height:45px;padding:12px 15px;margin-bottom:20px}.modal-header1,.modal-header2{text-transform:uppercase;font-weight:500;font-size:19px}.modal-header1{color:#2e2e2e}.modal-header2{color:#797979;margin-left:10px}#addCrossSectionModal .fa-plus-circle{color:#d0021b;margin-right:10px;font-size:19px;vertical-align:middle}.modal-footer{padding:0}.modal-footer .cancel-button,.modal-footer .red-button{margin:0;width:50%;border-radius:0;height:60px}.cancel-button{background-color:#2e2e2e;color:#fff;font-size:14px;padding:10px 20px;font-weight:400;letter-spacing:1.1px;box-shadow:0 2px 10px 0 rgba(0,0,0,.06);font-family:Roboto,sans-serif;text-transform:uppercase;outline:0;border:none}#addCrossSectionModal .red-button{font-size:14px;padding:10px 20px;font-weight:400;letter-spacing:1.1px;box-shadow:0 2px 10px 0 rgba(0,0,0,.06);font-family:Roboto,sans-serif;text-transform:uppercase;outline:0;border:none}.btn:disabled{opacity:.2}.red-button[disabled]:hover{background-color:#d0021b;opacity:.2;cursor:auto}`]
})
export class CrossSectionGridComponent implements OnInit {
  @Input() crossSectionComponent: CrossSectionManagmentComponent;
  isCrossSectionHidden = true;
  crossSectionGridData: CrossSectionModel[] = [];
  systemsArray: SystemModel[] = [];
  public selectedRowId;
  templateCrossSection = new CrossSectionModel();
  headers: string[] = ['Name', 'Description'];
  public formGroup: FormGroup;

  constructor(private mainPageService: MainPageService) { }

  public ngOnInit(): void {
    this.loadData();
    // this.mainPageService.mysubject.subscribe((value) => {
    //   this.updateCrossSectionInDb(value);
    // });
    this.mainPageService.deleteCrossSectionSubject.subscribe((value) => {
      this.crossSectionGridData = this.crossSectionGridData.filter(x => x._id !== value);
    });
    this.createForm();
  }

  loadData(): void {
    this.mainPageService.loadAllSystems().subscribe((response) => {
      this.systemsArray = response;
    });
    this.mainPageService.loadAllCrossSections().subscribe((response) => {
      this.crossSectionGridData = response;
    });
  }

  toggle() {
    const actionButtons = $('.mat-icon-button');
    $(actionButtons[1]).css('visibility', 'hidden');
    for (let i = 2; i < actionButtons.length; i += 2) {
      $(actionButtons[i]).css('visibility', 'hidden');
    }
    this.isCrossSectionHidden = !this.isCrossSectionHidden;
  }

  onConnectorClick(sender) {
    this.crossSectionComponent.showCrossSection(sender);
  }

  onRowClick(row, id) {
    this.selectedRowId = id;
    this.crossSectionComponent.showCrossSection(this.crossSectionGridData[row]);
  }

  updateCrossSectionInDb(id) {
    let dataToSend;
    let preparedData;
    for (const item of this.crossSectionGridData) {
      if (item._id === id) {
        dataToSend = item;
        break;
      }
    }
    for (const item of this.crossSectionGridData) {
      if (item._id === id) {
        preparedData = item;
        break;
      }
    }
    preparedData.articleNumber = dataToSend.articleNumber;
    preparedData.description = dataToSend.description;
    preparedData.name = dataToSend.name;
    this.mainPageService.updateCrossSectionInDb(JSON.stringify(preparedData)).subscribe(() => { });
  }

  saveNewCrossSection() {
    this.mainPageService.addNewCrossSectionIntoDb(JSON.stringify(this.templateCrossSection)).subscribe((response) => {
      this.templateCrossSection._id = response;
      this.crossSectionGridData.push(this.templateCrossSection);
      this.templateCrossSection = new CrossSectionModel();
    });
  }

  public prepareCreate() {
    this.templateCrossSection = new CrossSectionModel();
    this.createForm();
  }

  private createForm() {
    this.formGroup = new FormGroup({
      name: new FormControl(this.templateCrossSection.name, Validators.required),
      description: new FormControl(this.templateCrossSection.description),
      system: new FormControl(this.templateCrossSection.system, Validators.required),
      duenqName: new FormControl(this.templateCrossSection.duenqName, Validators.maxLength(50)),
    });
  }
}
